import React from "react";
import SectionShell from "./SectionShell";
import { ADVISOR_PHOTO } from "./Hero";

const FACTS = ["Founder & CEO, Prospera Financial", "Toronto, Ontario"];

export default function About() {
  return (
    <SectionShell
      id="about"
      eyebrow="Meet the Advisor"
      variant="elevated"
      data-testid="about"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div className="relative rounded-2xl overflow-hidden bg-gradient-to-b from-[#EEF1F7] to-white border border-[#E6E2D8] aspect-[4/5]">
            <img
              src={ADVISOR_PHOTO}
              alt="Biagio DiGirolamo"
              className="absolute inset-x-0 bottom-0 mx-auto h-[95%] w-auto object-contain object-bottom"
              data-testid="about-portrait"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <h2 className="font-display text-[#0B1F3F] text-4xl sm:text-5xl tracking-tight leading-[1.08]">
            Biagio DiGirolamo
          </h2>
          <p className="text-[#0F1B2D] text-lg md:text-xl leading-relaxed mt-6 max-w-2xl" data-testid="about-bio">
            I use my signature method to unlock the hidden power of insurance,
            giving you lifelong protection without lifelong payments. My
            approach leverages policy value while you’re alive, ensuring
            financial security without sacrificing what you’ve built for the
            future.
          </p>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#5A6476]" data-testid="about-facts">
            {FACTS.map((f, i) => (
              <li key={f} className="flex items-center gap-6">
                {i > 0 && <span className="h-3 w-px bg-[#CFC9BB]" />}
                {f}
              </li>
            ))}
          </ul>

          <blockquote className="mt-10 pt-8 border-t border-[#E6E2D8] font-display italic text-[#0B1F3F] text-2xl leading-snug max-w-xl">
            "Wealth isn't a spreadsheet. It's the freedom to say yes to your
            real life. My job is to build the boring, quiet machine that
            produces it."
          </blockquote>
        </div>
      </div>
    </SectionShell>
  );
}
